import { Reveal, SectionHeading } from "../Reveal";

export const Gallery = ({ items }) => (
  <section id="gallery" data-testid="gallery-section" className="py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          kicker="معرض الأعمال"
          title="شغلنا على أرض الواقع"
          desc="لقطات من ميدان العمل — فان نجم الإطارات والفنيون أثناء تقديم الخدمة في مواقع العملاء."
        />
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {items.map((g, i) => (
          <Reveal key={g.id} delay={(i % 3) * 0.08}>
            <div
              data-testid={`gallery-item-${g.id}`}
              className="group relative overflow-hidden rounded-xl border border-[#28282D] aspect-[4/3] hover:border-yellow-400/50 transition-colors duration-300"
            >
              <img
                src={g.image_url}
                alt={g.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
              <div className="absolute bottom-0 inset-x-0 p-5">
                {g.category && (
                  <span className="inline-block text-[11px] font-bold text-black bg-yellow-400 rounded-full px-3 py-1 mb-2">{g.category}</span>
                )}
                <div className="font-display font-bold text-white">{g.title}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
